import React from "react";
import useUser from "../../../customHooks/useUser";
import useOrganizationPermission from "../../../customHooks/useOrganizationPermission";
import {
  DEVELOPER,
  ORGANIZATION_OWNER,
  rolesHavePermission,
} from "../../../constants/organizationRoles";

const OrganizationPermission = (props) => {
  const { allowedRoles, allowedPermissions, children } = props;
  const user = useUser();
  const { organizationMembers } = useOrganizationPermission();

  const userHasAllowedRole = () => {
    // If no members loaded yet, don't show anything
    if (!organizationMembers || Object.keys(organizationMembers).length === 0) {
      return false;
    }

    // Find the current user's membership
    const userMembership = Object.values(organizationMembers).find(
      (m) => m.uuid === user.uuid
    );

    // If user is not a member, don't show
    if (!userMembership) {
      return false;
    }

    // If specific roles are provided, check against them
    if (allowedRoles && allowedRoles.length > 0) {
      return userMembership.roles.some((role) => allowedRoles.includes(role));
    }

    // If permissions are provided, any one of them granted by the member's roles is enough
    if (allowedPermissions && allowedPermissions.length > 0) {
      return allowedPermissions.some((permission) =>
        rolesHavePermission(userMembership.roles, permission)
      );
    }

    // Default: allow for developers and owners only
    return userMembership.roles.some(
      (role) => role === DEVELOPER || role === ORGANIZATION_OWNER
    );
  };

  return userHasAllowedRole() ? children : null;
};

export default OrganizationPermission;
